import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=ff93c51a&scoped=true&"
import script from "./IndexView.vue?vue&type=script&lang=js&"
export * from "./IndexView.vue?vue&type=script&lang=js&"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=ff93c51a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff93c51a",
  null
  
)

export default component.exports